module.exports = __webpack_public_path__ + "media/images/app/collections/stackable-rings-b63618109f8b1954f849d326a4b39452.webp";